<template>
  <div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
    <div class="flex flex-wrap justify-center mb-10" v-lazy-container="{ selector: 'img' }">
      <div class="w-full w-full lg:w-9/12 bg-primary-300 rounded-md p-6">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-1/2">
            <a href="#" class="text-secondary-300 font-semibold text-lg mt-20 block">
              <i class="fas fa-folder-open ml-4"></i>{{ sub_category.name }}
            </a>
          </div>
          <div class="w-full lg:w-1/2 justify-last">
            <figure class="h-56">
              <img class="h-full w-full object-contain" :data-src="sub_category.image ? sub_category.image : '/front/img/dummy_data/banner1.png'" :alt="sub_category.name">
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap content-center justify-start">
      <div class="w-full sm:w-6/12 lg:w-9/12 pt-2">
        <ul class="breadcrumb text-sm md:text-base">
          <li>
            <a href="/">الرئيسية</a>
          </li>
          <li>
            <a :href="categoryUrl">{{ sub_category.parent.name }}</a>
          </li>
          <li class="is-active">
            <p>{{ sub_category.name }}</p>
          </li>
        </ul>
      </div>
      <div class="w-full sm:w-6/12 lg:w-3/12">
        <div class="filter">
          <form class="">
            <label class="flex text-secondary-300 text-sm font-semibold">
              <span class="flex-shrink-0 self-center rtl:ml-4 ltr:mr-4">{{ t('order_by') }}</span>
              <div class="select block w-full">
                <select class="form-select w-full border-secondary-300 rounded-lg text-sm" v-model="orderBy" name="brand_filter">
                  <option selected value="name">{{ t('name') }}</option>
                  <option value="created_at">{{ t('last_added')}}</option>
                  <option value="views">{{ t('views') }}</option>
                  <option value="price_desc">{{ t('high_price')  }}</option>
                  <option value="price_asc">{{ t('low_price') }}</option>
                </select>
              </div>
            </label>
          </form>
        </div>
      </div>

      <div class="w-full sm:w-4/12 lg:w-3/12 p-4 mt-4">
        <div class="sidebar shadow-md rounded-lg overflow-hidden" v-if="windowWidth > 640">
          <div class="bg-primary p-3">
            <p class="text-white font-bold">{{ t('filter_label') }}</p>
          </div>
          <div class="bg-white">
            <div class="price border-t border-gray-400 mb-3">
              <p class="text-sm bg-gray-200 px-3 py-2">{{ t('price_label') }}</p>
              <div class="flex text-center content p-3">
                <label class="px-3">
                  <p class="text-sm">{{ t('from_label')}}</p>
                  <input v-model="min_price" class="input mt-2" type="number"  min="0" value="0">
                </label>
                <label class="px-3">
                  <p class="text-sm">{{ t('to_label')}}</p>
                  <input v-model="max_price" class="input mt-2" type="number"  min="0" value="0">
                </label>
              </div>
            </div>
            <div class="brands border-t border-gray-400 mb-3">
              <p class="text-sm bg-gray-200 px-3 py-2">{{ t('brands_label') }}</p>
              <div class="content p-3 h-48  ml-3 mt-2 overflow-y-auto scrollbar-thumb-secondary-300 scrollbar-track-gray-300 hover:scrollbar-thumb-gray-600 scrollbar-2xs">
                <label class="checkbox mt-1" v-for="(brand) in brands">
                  <div class="ltr:mr-3 rtl:ml-3 focus-within:border-secondary-100 border-secondary-100">
                    <input class="opacity-0 absolute" v-model="brandIds" :value="brand.id" :id="brand.name"  type="checkbox">
                    <i class="text-secondary-300 icon-check"></i>
                  </div>
                  <p class="select-none">{{ brand.name }}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar shadow-md rounded-lg overflow-hidden" v-else>
          <div class="bg-primary p-3">
            <p class="text-white font-bold">{{ t('filter_label') }}</p>
          </div>
          <div class="flex flex-wrap justify-start text-center collapse-container" ref="active">
            <div class="w-1/3 p-3" :class="['price' == activeItem ? 'is-active' : '']">
              <a href="#" @click.prevent="controlCollapse('price' , $el , $event , 0 , 1 )">
                <i class="w-12 h-12 m-auto text-white text-3xl rounded-full leading-12-important bg-primary block icon icon-money-bag"></i>
                <p class="text-primary text-sm">{{ t('price_label') }}</p>
              </a>

            </div>
            <div class="w-1/3 p-3" :class="['brands' == activeItem ? 'is-active' : '']">
              <a href="#" @click.prevent="controlCollapse('brands' , $el , $event , 0 , 2 )">
                <i class="w-12 h-12 m-auto text-white text-3xl rounded-full leading-12-important bg-primary block icon icon-brand"></i>
                <p class="text-primary text-sm">{{ t('brands_label') }}</p>
              </a>
            </div>
            <div v-if="activeItem" class="w-full">
              <div class="card-content" v-if="activeIndex == 1" ref="sub">
                <div class="flex text-center content p-3">
                  <label class="px-3 w-1/2">
                    <p class="text-sm">{{ t('from_label')}}</p>
                    <input v-model="min_price" class="input mt-2" type="number"  min="0" value="0">
                  </label>
                  <label class="px-3 w-1/2">
                    <p class="text-sm">{{ t('to_label')}}</p>
                    <input v-model="max_price" class="input mt-2" type="number"  min="0" value="0">
                  </label>
                </div>
              </div>
              <div class="card-content" v-if="activeIndex == 2" ref="sub">
                <div class="content p-3 max-h-48  ml-3 mt-2 overflow-y-auto scrollbar-thumb-secondary-300 scrollbar-track-gray-300 hover:scrollbar-thumb-gray-600 scrollbar-2xs">
                  <label class="checkbox mt-1" v-for="(brand) in brands">
                    <div class="ltr:mr-3 rtl:ml-3 focus-within:border-secondary-100 border-secondary-100">
                      <input class="opacity-0 absolute" v-model="brandIds" :value="brand.id" :id="brand.name"  type="checkbox">
                      <i class="text-secondary-300 icon-check"></i>
                    </div>
                    <p class="select-none">{{ brand.name }}</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full sm:w-8/12 lg:w-9/12 py-4 px-1">
        <div class="flex flex-wrap content-center justify-start" v-lazy-container="{ selector: 'img' }">
          <product-card v-for="product in products" :key="product.id" :sitelocale="lang" :auth="auth" :product="product" :is-fav="'true'"
                        fav-route="#" compare="#" :slider="false" store="#"></product-card>
        </div>
        <div class="has-text-centered m-t-30" v-show="loadMore">
          <a href="#" class="load-more">
            <img src="/front/img/illustrations/load_more.svg">
            <span>{{ t('more') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import infiniteScroll from 'vue-infinite-scroll';
export default {
  name: "CategoryFilter",
  directives: {
    infiniteScroll
  },
  props: {
    lang:{
      type: String,
      required: true
    },
    categoryUrl:{
      required: true,
      type: String,
    },
    url: String,
    currency: String,
    sub_category: {
      type: Object,
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
    auth: {
      type: String,
      required: true
    }
  },
  computed: {
    busy() {
      return this.fetching
    }
  },
  data(){
    return {
      currentPage: 0,
      min_price:0,
      max_price:0,
      fetching: true,
      loadMore : false,
      nextUrl : String,
      orderBy: 'name',
      sortOrder: 'asc',
      products: [],
      brandIds: [],
      filter: 'name',
      mobile:false,
      activeItem: null,
      activeIndex:null,
    };
  },
  created() {
    this.nextUrl = this.url;
    this.products = [];
    this.loadNextPage();
  },
  mounted() {
    this.$translate.setLang(this.lang);
  },
  methods: {
    loadNextPage() {
      this.getOrderBy(this.orderBy);
      this.currentPage++;
      this.fetching = true;
      if(this.nextUrl != null){
        axios.get(this.nextUrl,
            {
              params : {
                'orderBy' : this.filter, 'direction' : this.sortOrder,
              }
            }
        ).then(({ data }) => {
          this.products.push(...data.data);
          if(data.links.next != null) {
            this.nextUrl = data.links.next;
          } else {
            this.nextUrl = data.links.next;
          }
          this.fetching = false;
        });
      }
      else{
        this.loadMore = false;
      }
    },
    getOrderBy(val) {
      if(val == 'price_asc') {
        this.sortOrder = 'asc';
        this.filter = 'price';
      } else if(val == 'price_desc') {
        this.sortOrder = 'desc';
        this.filter = 'price';
      } else {
        this.sortOrder = 'desc';
        this.filter = val;
      }
    },
    controlCollapse(item , el , event , index , increment){
      this.activeIndex = increment;
      if(item == this.activeItem){
        this.activeItem= null
      }else{
        this.activeItem = item;
      }
      if(this.activeItem){
        setTimeout(() => {
          this.$refs.sub.classList.contains("is-active") ? this.$refs.sub.classList.remove('is-active') : '';
          if(this.$refs.sub.classList.contains("is-active")){
            this.$refs.sub.classList.remove('is-active') ;
          }
          else{
            this.$refs.sub.classList.add('is-active') ;
          }
        }, 100)
      }
    },
  },
  watch: {
    orderBy: function (val) {
      this.getOrderBy(val);
      this.products = [];
      axios.get(this.url,
          {
            params : {
              'orderBy' : this.filter, 'direction' : this.sortOrder, 'brand_id' : this.brandIds,
              'min_price' : this.min_price, 'max_price' : this.max_price,
            }
          }
      )
          .then(({data}) => {
            this.products = data.data;
            if(data.links.next != null) {
              this.loadMore = true;
              this.nextUrl = data.links.next;
            } else {
              this.nextUrl = data.links.next;
              this.loadMore = false;
            }
            this.currentPage = 0;
            this.fetching = false;
          });
    },
    min_price : function (val) {
      this.products = [];
      this.getOrderBy(this.orderBy);
      axios.get(this.url,
          {
            params : {
              'orderBy' : this.filter, 'direction' : this.sortOrder, 'brand_id' : this.brandIds,
              'min_price' : this.min_price, 'max_price' : this.max_price,
            }
          }
      ).then(({data}) => {
        this.products = data.data;
        if(data.links.next != null) {
          this.loadMore = true;
          this.nextUrl = data.links.next;
        } else {
          this.loadMore = false;
          this.nextUrl = data.links.next;
        }
        this.currentPage = 0;
        this.fetching = false;
      });
    },
    max_price : function (val) {
      this.products = [];
      this.getOrderBy(this.orderBy);
      axios.get(this.url,
          {
            params : {
              'orderBy' : this.filter, 'direction' : this.sortOrder, 'brand_id' : this.brandIds,
              'min_price' : this.min_price, 'max_price' : this.max_price,
            }
          }
      ).then(({data}) => {
        this.products = data.data;
        if(data.links.next != null) {
          this.loadMore = true;
          this.nextUrl = data.links.next;
        } else {
          this.loadMore = false;
          this.nextUrl = data.links.next;
        }
        this.currentPage = 0;
        this.fetching = false;
      });
    },
    brandIds : function (val) {
      this.products = [];
      this.getOrderBy(this.orderBy);
      axios.get(this.url,
          {
            params : {
              'orderBy' : this.filter, 'direction' : this.sortOrder, 'brand_id' : this.brandIds,
              'min_price' : this.min_price, 'max_price' : this.max_price,
            }
          }
      ).then(({data}) => {
        this.products = data.data;
        if(data.links.next != null) {
          this.loadMore = true;
          this.nextUrl = data.links.next;
        } else {
          this.loadMore = false;
          this.nextUrl = data.links.next;
        }
        this.currentPage = 0;
        this.fetching = false;
      });
    },
  },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Category/SubCategoryProducts.vue